const eventTarget = new EventTarget()
const EVENT_NAME = "dupla-confirmacao"

export function dispatchDuplaConfirmacao(
    {
        open,
        cancelAction,
        confirmAction,
        title,
        description,
        confirmTextButton = "Sim",
        cancelIcon,
        confirmIcon,
    }) {
    eventTarget.dispatchEvent(
        new CustomEvent("dupla-confirmacao", {
            detail: {
                open,
                cancelAction,
                confirmAction,
                title,
                description,
                confirmTextButton,
                cancelIcon,
                confirmIcon,
            },
        })
    )
}

export function subscribeDuplaConfirmacao(listener) {
    const handler = (event) => {
        const detail = event.detail || {}
        listener(detail)
    }

    eventTarget.addEventListener(EVENT_NAME, handler)
    return () => eventTarget.removeEventListener(EVENT_NAME, handler)
}